import styles from "./index.module.less";
import { useUser } from "@/utils/UserContext";
import {
  Iconsvg,
  InputField,
  ButtonField,
  SelectField,
  Combobox,
  ComboboxSuggestion,
} from "@wk/components-react16";
import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import logo from "@/assets/img/logo-screen.png";
import {
  getPlayerDetail,
  getCode,
  verifySmsCode,
  editUser,
  addUser,
} from "@/services/user";
import ModalConfirm from "../player/modal";
import AddYyModal from "../player/modal/addYy";
import { useNavigate } from "react-router-dom";
import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
  checkDict,
  addDictItem,
} from "@/services/history";
import { provinceAndCityData } from "@/utils/areaDataUtil";
import { cloneDeep } from "lodash-es";
import { TreeSelect } from "antd";

const phoneRegex = /^1[3-9]\d{9}$/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const step = [
  {
    label: "验证手机号",
    labelId: "step1",
    icon: "smartphone",
  },
  {
    label: "填写账号信息",
    labelId: "step2",
    icon: "mail-address",
  },
  {
    label: "完成注册",
    labelId: "step3",
    icon: "check-circle",
  },
];

const provinceList = cloneDeep(provinceAndCityData);

const Registered = () => {
  const navigate = useNavigate();
  const { set } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [phoneValue, setPhoneValue] = useState("");
  const [inputStatus, setInputStatus] = useState("none");
  const [stepActive, setStepActive] = useState("step1");
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isGetCode, setIsGetCode] = useState(false);
  const [second, setSecond] = useState(0);
  const [isShowModal, setIsShowModal] = useState(false);
  const [firstCode, setFirstCode] = useState("");
  const [secondCode, setSecondCode] = useState("");
  const [thirdCode, setThirdCode] = useState("");
  const [forthCode, setForthCode] = useState("");

  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [isVerifyError, setIsVerifyError] = useState(false);
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);
  const [yyList, setYyList] = useState([]);

  const codeNumFirstRef = useRef(null);
  const codeNumSecondRef = useRef(null);
  const codeNumThirdRef = useRef(null);
  const codeNumForthRef = useRef(null);

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const errorText = useMemo(() => {
    if (inputStatus === "none") {
      return [];
    }
    if (!phoneValue) {
      return [{ label: "请输入手机号", labelId: "1" }];
    }

    if (!phoneRegex.test(phoneValue)) {
      return [{ label: "请输入正确的手机号", labelId: "2" }];
    }

    // return [{ label: "您的账号未注册,需要注册后才能登录", labelId: "3" }];
    return [];
  }, [inputStatus, phoneValue]);

  const next = async () => {
    if (!phoneValue || !phoneRegex.test(phoneValue)) {
      setInputStatus("error");
      return;
    }

    setIsNextLoading(true);

    const resUser = await getPlayerDetail(phoneValue);
    if (resUser.code === 200) {
      if (
        resUser?.result?.current &&
        resUser?.result?.current?.status === "1"
      ) {
        // 已注册
        setIsShowModal(true);
      } else {
        if (resUser?.result?.current) {
          let value = cloneDeep(resUser?.result?.current);
          value?.keshi
            ? (value.keshi = value?.keshi.split(","))
            : (value.keshi = []);
          setUserInfo({ ...value, phone: phoneValue });
        } else {
          setUserInfo({
            phone: phoneValue,
          });
        }
        const resCode = await getCode(phoneValue);
        // 开始倒计时
        let time = 60;
        setSecond(--time);
        let clearTimer = setInterval(() => {
          setSecond(--time);
          if (time < 1) {
            clearInterval(clearTimer);
          }
        }, 1000);
        if (resCode.code === 200) {
          setIsGetCode(true);
          setTimeout(() => {
            codeNumFirstRef.current.focus();
          }, 1000);
        } else if (resCode.code === 500) {
          setMessageText("短信验证码发送失败，请稍后重试");
          setIsMessageOpen(true);
        }
      }
    }

    setIsNextLoading(false);
  };

  const getCodeByPhone = async () => {
    const resCode = await getCode(phoneValue);
    // 开始倒计时
    let time = 60;
    setSecond(--time);
    let clearTimer = setInterval(() => {
      setSecond(--time);
      if (time < 1) {
        clearInterval(clearTimer);
      }
    }, 1000);

    if (resCode?.code === 500) {
      setMessageText("短信验证码发送失败，请稍后重试");
      setIsMessageOpen(true);
    }
  };

  const delText = useMemo(() => {
    return ` ${phoneValue.slice(0, 3)}****${phoneValue.slice(
      phoneValue.length - 4
    )}`;
  }, [phoneValue]);

  const verifyCode = async (
    valueFirst,
    valueSecond,
    valueThird,
    valueForth
  ) => {
    if (!valueFirst || !valueSecond || !valueThird || !valueForth) {
      return;
    }

    setIsVerifyLoading(true);
    const res = await verifySmsCode(
      `${valueFirst}${valueSecond}${valueThird}${valueForth}`,
      phoneValue
    );
    if (res.code === 200) {
      setStepActive("step2");
    }

    if (res?.code === 500) {
      setIsVerifyError(true);
    }

    setIsVerifyLoading(false);
  };

  const [nameStatus, setNameStatus] = useState("none");

  const nameErrorText = useMemo(() => {
    if (nameStatus === "none") {
      return [];
    }
    if (!userInfo?.userName) {
      return [{ label: "请输入选手姓名", labelId: "1" }];
    }

    if (userInfo?.userName.length < 2) {
      return [{ label: "请输入至少2个字符", labelId: "2" }];
    }

    return [];
  }, [nameStatus, userInfo?.userName]);

  const [emailStatus, setEmailStatus] = useState("none");

  const emailErrorText = useMemo(() => {
    if (emailStatus === "none") {
      return [];
    }
    if (!userInfo?.email) {
      return [{ label: "请输入邮箱", labelId: "1" }];
    }

    if (userInfo?.email.length < 6) {
      return [{ label: "请输入至少6个字符", labelId: "2" }];
    }

    if (!emailRegex.test(userInfo?.email)) {
      return [{ label: "请输入正确的邮箱地址", labelId: "3" }];
    }

    return [];
  }, [emailStatus, userInfo?.email]);

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };
  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const getYyList = async (value) => {
    const zcList = await getCaseTypeDict("yy");
    setYyList(zcList);
    if (value) {
      let itemFind = zcList.find((item) => {
        return item?.itemValue === value;
      });
      if (itemFind) {
        onComboboxValueChange(itemFind);
      }
    }
  };

  const municipalityList = useMemo(() => {
    let itemFind = provinceList.find((item) => {
      return userInfo?.shengfen === item.label;
    });
    if (itemFind) {
      return itemFind.children;
    }
    return [];
  }, [userInfo?.shengfen]);

  const save = async () => {
    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }

    if (
      !userInfo?.email ||
      userInfo?.email.length < 6 ||
      !emailRegex.test(userInfo?.email)
    ) {
      setEmailStatus("error");
      return;
    }

    userInfo.status = "1";
    let res = null;
    setIsNextLoading(true);
    const value = cloneDeep(userInfo);
    value?.keshi ? (value.keshi = value?.keshi.join()) : (value.keshi = "");
    if (value?.id) {
      res = await editUser(value);
    } else {
      res = await addUser(value);
    }
    if (res?.code === 200) {
      setStepActive("step3");
      set({ ...value, id: res?.result });
    }
    setIsNextLoading(false);
  };
  const [isValueError, setIsValueError] = useState(false);
  const [isAddYyOpen, setIsAddYyOpen] = useState(false);
  const [isAddYyLoading, setIsAddYyLoading] = useState(false);
  const [isYyDropdownOpen, setIsYyDropdownOpen] = useState(false);
  const [yyComboboxValue, setYyComboboxValue] = useState({});
  const [yyComboboxInputValue, setYyComboboxInputValue] = useState("");

  const getFilteredOptions = useCallback(() => {
    const value = cloneDeep(yyComboboxInputValue);

    if (yyComboboxValue?.itemText === value) {
      return yyList;
    }

    const filteredOptions = yyList.filter((item) => {
      return item?.itemText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    if (filteredOptions.length === 0) {
      return [{ itemText: `+ 添加机构 ${value}`, id: "create" }];
    }

    return filteredOptions;
  }, [yyComboboxInputValue, yyComboboxValue, yyList]);

  const onClear = () => {
    setYyComboboxInputValue("");
    // setYyComboboxValue({});
    // setUserInfo({ ...userInfo, hospital: "" });
  };

  const onInputClick = () => {
    setIsYyDropdownOpen(true);
  };

  const onComboboxValueChange = (e) => {
    setIsYyDropdownOpen(false);

    if (e?.id !== "create") {
      setYyComboboxInputValue(e?.itemText);
      setYyComboboxValue(e);
      setUserInfo({ ...userInfo, hospital: e?.id });
    } else {
      setIsAddYyOpen(true);
    }
  };

  const onKey = (e) => {
    const { value } = e.target;
    setYyComboboxInputValue(value);
    if (value !== "") {
      setIsYyDropdownOpen(true);
    }
  };

  const addYy = async (value, callBack) => {
    setIsAddYyLoading(true);

    try {
      const res = await getDictIdByCode({ code: "yy" });
      if (!res?.success || !res?.result?.records?.length) {
        setIsAddYyLoading(false);
        return;
      }

      const dictId = res?.result?.records[0]?.id;
      // const checkRes = await checkDict({ dictId, itemValue: value.value });
      // if (checkRes?.code !== 200) {
      //   setIsAddYyLoading(false);
      //   setIsValueError(true);
      //   return;
      // }

      const resAdd = await addDictItem({
        dictId,
        itemText: value.name,
        itemValue: value.value,
      });
      if (resAdd?.code === 200) {
        await getYyList(value.value);
        setIsAddYyOpen(false);
        callBack();
      }
    } catch (error) {
      setIsAddYyLoading(false);
    }

    setIsAddYyLoading(false);
  };

  useEffect(() => {
    verifyCode(firstCode, secondCode, thirdCode, forthCode);
  }, [firstCode, secondCode, thirdCode, forthCode]);

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
    getYyList();
  }, []);

  return (
    <div className={styles["registered-view"]}>
      <div className="login-box">
        <div className="login-box-content">
          <img src={logo} alt="logo" />

          {stepActive === "step3" ? (
            <div className="step3-box">
              <img
                src="https://cdn.wolterskluwer.io/wk/jumpstart-v3-assets/0.x.x/icons/illustrated/light/large/no-favorites.svg"
                alt="No favorites - large"
              />
              <div className="step3-success">注册成功</div>

              <div className="step3-text">请妥善保管您的账户信息</div>

              <div className="step3-btn">
                <div>
                  <ButtonField>
                    <button type="button" onClick={() => navigate("/player")}>
                      查看个人中心
                    </button>
                  </ButtonField>
                </div>

                <div>
                  <ButtonField mode={"ghost"}>
                    <button type="button" onClick={() => navigate("/")}>
                      进入首页
                    </button>
                  </ButtonField>
                </div>
              </div>
            </div>
          ) : (
            <div className="modal-body-content">
              <div className="modal-text">注册</div>

              <div className="modal-step">
                <div className="connector"></div>
                {step.map((item) => {
                  return (
                    <div
                      className={
                        item.labelId === stepActive ? "step active" : "step"
                      }
                      key={item.labelId}
                    >
                      <div className="step-circle">
                        <Iconsvg
                          name={item.icon}
                          size={24}
                          color={
                            item.labelId === stepActive ? "#ffffff" : "#232323"
                          }
                        />
                      </div>
                      <span className="step-label">{item.label}</span>
                    </div>
                  );
                })}
              </div>

              {/* 第一步且没有获取验证码 */}
              {stepActive === "step1" && !isGetCode && (
                <>
                  <div className="step1-phone-input">
                    <InputField
                      label="手机号"
                      labelFor="input-id-1-2"
                      status={inputStatus}
                      errors={errorText}
                    >
                      <input
                        type="text"
                        id="input-id-1-2"
                        name="input-1-2"
                        placeholder="请输入手机号"
                        value={phoneValue}
                        onChange={(e) => {
                          setPhoneValue(e.target.value);
                          if (
                            !e.target.value ||
                            !phoneRegex.test(e.target.value)
                          ) {
                            setInputStatus("error");
                            return;
                          }

                          setInputStatus("none");
                        }}
                        maxLength="11"
                      />
                    </InputField>
                  </div>

                  <div className="modal-button continue">
                    <ButtonField>
                      <button
                        type="button"
                        onClick={() => next()}
                        disabled={isNextLoading || !(second < 1)}
                      >
                        {second < 1 ? "下一步" : `下一步(${second}s后重发)`}
                        {isNextLoading && (
                          <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                        )}
                      </button>
                    </ButtonField>
                  </div>
                </>
              )}

              {/* 第一步且已经获取验证码 */}
              {stepActive === "step1" && isGetCode && (
                <div className="code-box">
                  <div className="first">
                    注册需要进行验证码确认，请通过手机接收验证码
                  </div>
                  <div className="second">
                    <div className="title-text">当前账户安全手机:</div>
                    <div className="phone-number">{delText}</div>
                  </div>

                  <div className="third">
                    <div className="first-code-number">
                      <InputField
                        labelFor="input-id-1-3"
                        isDisabled={isVerifyLoading}
                      >
                        <input
                          ref={codeNumFirstRef}
                          type="text"
                          id="input-id-1-3"
                          name="input-1-3"
                          value={firstCode}
                          onChange={(e) => {
                            setFirstCode(e.target.value);
                            setIsVerifyError(false);
                            if (e.target.value) {
                              codeNumSecondRef.current.focus();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value) {
                              codeNumSecondRef.current.focus();
                            }
                          }}
                          maxLength="1"
                          readOnly={isVerifyLoading}
                        />
                      </InputField>
                    </div>
                    <div className="second-code-number">
                      <InputField
                        labelFor="input-id-1-4"
                        isDisabled={isVerifyLoading}
                      >
                        <input
                          ref={codeNumSecondRef}
                          type="text"
                          id="input-id-1-4"
                          name="input-1-4"
                          value={secondCode}
                          onChange={(e) => {
                            setSecondCode(e.target.value);
                            setIsVerifyError(false);
                            if (e.target.value) {
                              codeNumThirdRef.current.focus();
                            } else {
                              codeNumFirstRef.current.focus();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value) {
                              codeNumThirdRef.current.focus();
                            } else {
                              codeNumFirstRef.current.focus();
                            }
                          }}
                          maxLength="1"
                          readOnly={isVerifyLoading}
                        />
                      </InputField>
                    </div>
                    <div className="third-code-number">
                      <InputField
                        labelFor="input-id-1-5"
                        isDisabled={isVerifyLoading}
                      >
                        <input
                          ref={codeNumThirdRef}
                          type="text"
                          id="input-id-1-5"
                          name="input-1-5"
                          value={thirdCode}
                          onChange={(e) => {
                            setThirdCode(e.target.value);
                            setIsVerifyError(false);
                            if (e.target.value) {
                              codeNumForthRef.current.focus();
                            } else {
                              codeNumSecondRef.current.focus();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value) {
                              codeNumForthRef.current.focus();
                            } else {
                              codeNumSecondRef.current.focus();
                            }
                          }}
                          maxLength="1"
                          readOnly={isVerifyLoading}
                        />
                      </InputField>
                    </div>
                    <div className="fourth-code-number">
                      <InputField
                        labelFor="input-id-1-6"
                        isDisabled={isVerifyLoading}
                      >
                        <input
                          ref={codeNumForthRef}
                          type="text"
                          id="input-id-1-6"
                          name="input-1-6"
                          value={forthCode}
                          onChange={(e) => {
                            setForthCode(e.target.value);
                            setIsVerifyError(false);
                            if (!e.target.value) {
                              codeNumThirdRef.current.focus();
                            }
                          }}
                          onInput={(e) => {
                            if (!e.target.value) {
                              codeNumThirdRef.current.focus();
                            }
                          }}
                          maxLength="1"
                          readOnly={isVerifyLoading}
                        />
                      </InputField>
                    </div>
                  </div>
                  {isVerifyError && (
                    <div className="cg-field-error">验证码错误</div>
                  )}

                  <div className="fourth">
                    <div>
                      <ButtonField mode={"ghost"}>
                        <button
                          type="button"
                          onClick={() => {
                            setIsGetCode(false);
                            setFirstCode("");
                            setSecondCode("");
                            setThirdCode("");
                            setForthCode("");
                            setIsVerifyError(false);
                          }}
                          disabled={isVerifyLoading}
                        >
                          上一步
                        </button>
                      </ButtonField>
                    </div>

                    <div>
                      <ButtonField>
                        <button
                          type="button"
                          onClick={() => getCodeByPhone()}
                          disabled={
                            isNextLoading || !(second < 1) || isVerifyLoading
                          }
                        >
                          {second < 1
                            ? "重新发送"
                            : `${second}秒后可重新获取短信)`}
                          {isNextLoading && (
                            <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                          )}
                        </button>
                      </ButtonField>
                    </div>
                  </div>
                </div>
              )}

              {/* 第二步 */}

              {stepActive === "step2" && (
                <div className="step2-box">
                  <div>
                    <InputField
                      label="选手姓名"
                      labelFor="input-id-1-1"
                      indicator="required"
                      status={nameStatus}
                      errors={nameErrorText}
                    >
                      <input
                        type="text"
                        id="input-id-1-1"
                        name="input-1-1"
                        placeholder="请输入选手姓名"
                        required
                        value={userInfo?.userName}
                        onChange={(e) => {
                          setUserInfo({
                            ...userInfo,
                            userName: e.target.value,
                          });
                          if (!e.target.value || e.target.value.length < 2) {
                            setNameStatus("error");
                            return;
                          }
                          setNameStatus("none");
                        }}
                        maxLength={16}
                        minLength={2}
                      />
                    </InputField>
                  </div>

                  <div>
                    <SelectField label="职称" labelFor="select-id-1-1">
                      <select
                        id="select-id-1-1"
                        name="story1-1"
                        value={userInfo?.zhicheng || ""}
                        onChange={(e) => {
                          setUserInfo({
                            ...userInfo,
                            zhicheng: e.target.value,
                          });
                        }}
                      >
                        <option disabled hidden value={""}>
                          请选择职称或职务
                        </option>
                        {zcList.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.itemText}
                            </option>
                          );
                        })}
                      </select>
                    </SelectField>
                  </div>

                  <div>
                    {/* <SelectField label="机构" labelFor="select-id-2-1">
                      <select
                        id="select-id-2-1"
                        name="story1-2"
                        value={userInfo?.hospital || ""}
                        onChange={(e) => {
                          setUserInfo({
                            ...userInfo,
                            hospital: e.target.value,
                          });
                        }}
                      >
                        <option disabled hidden value={""}>
                          请选择机构
                        </option>
                        {yyList.map((item) => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.itemText}
                            </option>
                          );
                        })}
                      </select>
                    </SelectField> */}

                    <Combobox
                      isOpen={isYyDropdownOpen}
                      hasClearButton={isYyDropdownOpen && yyComboboxInputValue}
                      onDropdownUserRequest={(event) => {
                        setIsYyDropdownOpen(event);
                        setYyComboboxInputValue(yyComboboxValue.itemText);
                      }}
                      onClearUserRequest={onClear}
                      label="机构"
                    >
                      <input
                        placeholder="请选择机构"
                        value={yyComboboxInputValue}
                        onClick={onInputClick}
                        onInput={(event) => onKey(event)}
                        slot="comboboxInput"
                        maxLength={20}
                      />
                      {Object.values(getFilteredOptions()).map((item, idx) => {
                        return (
                          <React.Fragment key={item.id}>
                            <ComboboxSuggestion
                              isSelected={item.id === yyComboboxValue.id}
                              onItemClick={() => onComboboxValueChange(item)}
                              slot="comboboxSuggestion"
                            >
                              {item.itemText}
                            </ComboboxSuggestion>
                          </React.Fragment>
                        );
                      })}
                    </Combobox>
                  </div>

                  <div className="department">
                    <div className="header">科室</div>
                    <TreeSelect
                      style={{ width: "100%" }}
                      value={userInfo?.keshi}
                      styles={{
                        popup: { root: { maxHeight: 400, overflow: "auto" } },
                      }}
                      treeData={ksList}
                      placeholder="请选择科室"
                      treeDefaultExpandAll
                      onChange={(value) => {
                        setUserInfo({ ...userInfo, keshi: value });
                      }}
                      multiple
                      maxCount={5}
                      size="large"
                      showSearch
                      treeNodeFilterProp="title"
                      fieldNames={{
                        value: "key",
                      }}
                    />
                  </div>

                  <div>
                    <SelectField label="所在省" labelFor="select-id-3-1">
                      <select
                        id="select-id-3-1"
                        name="story3-2"
                        value={userInfo?.shengfen || ""}
                        onChange={(e) => {
                          setUserInfo({
                            ...userInfo,
                            shengfen: e.target.value,
                            chengshi: "",
                          });
                        }}
                      >
                        <option disabled hidden value={""}>
                          请选择所在省
                        </option>

                        {provinceList?.map((item) => {
                          return (
                            <option key={item.label} value={item.label}>
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                    </SelectField>
                  </div>

                  <div>
                    <SelectField label="所在市" labelFor="select-id-2-1">
                      <select
                        id="select-id-2-1"
                        name="story2-1"
                        value={userInfo?.chengshi || ""}
                        onChange={(e) => {
                          setUserInfo({
                            ...userInfo,
                            chengshi: e.target.value,
                          });
                        }}
                      >
                        <option disabled hidden value={""}>
                          请选择所在市
                        </option>
                        {municipalityList?.map((item) => {
                          return (
                            <option key={item.label} value={item.label}>
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                    </SelectField>
                  </div>

                  <div>
                    <InputField
                      label="电子邮箱"
                      labelFor="input-id-1-2"
                      indicator="required"
                      status={emailStatus}
                      errors={emailErrorText}
                    >
                      <input
                        type="text"
                        id="input-id-1-2"
                        name="input-1-2"
                        placeholder="请输入电子邮箱"
                        required
                        value={userInfo?.email}
                        onChange={(e) => {
                          setUserInfo({ ...userInfo, email: e.target.value });
                          if (
                            !e.target.value ||
                            e.target.value.length < 6 ||
                            !emailRegex.test(e.target.value)
                          ) {
                            setEmailStatus("error");
                            return;
                          }
                          setEmailStatus("none");
                        }}
                        maxLength={100}
                        minLength={6}
                      />
                    </InputField>
                  </div>

                  <div className="modal-button step2-continue">
                    <ButtonField>
                      <button
                        type="button"
                        onClick={() => save()}
                        disabled={isNextLoading}
                      >
                        下一步
                        {isNextLoading && (
                          <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                        )}
                      </button>
                    </ButtonField>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <ModalConfirm
        isOpen={isShowModal}
        onClose={() => {
          setIsShowModal(false);
        }}
        children={
          <div className="modal-body-text">您的帐号已注册，是否跳转登录页?</div>
        }
        title={"提示"}
        onConfirm={() => navigate("/login")}
        okText="确认"
      />

      <AddYyModal
        nameValue={yyComboboxInputValue}
        isOpen={isAddYyOpen}
        onClose={() => {
          setIsAddYyOpen(false);
        }}
        title="添加机构"
        onConfirm={(value, callBack) => {
          addYy(value, callBack);
        }}
        isConfirmLoading={isAddYyLoading}
        height="auto"
        okText="提交"
      />

      <ModalConfirm
        isOpen={isValueError}
        onClose={() => {
          setIsValueError(false);
        }}
        children={
          <div className="modal-body-text">数据值不可用，系统中已存在！</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          setIsValueError(false);
        }}
        okText="确定"
      />

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default Registered;
